<template lang="pug">
md-layout(md-column)
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Series', :nav='nav')
    router-link(:to='{ name: "CreateSerie" }')
      md-button#btn-add-series.md-fab.md-fab-bottom-right.md-icon-button
        md-icon(md-iconset="fa fa-plus")
    serie-table.content-table
</template>

<script>
  import SerieTable from '../../shared-components/serie/SerieTable.vue';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      SerieTable,
      Breadcrumbs
    },
    computed: {
      nav() {
        return [
          { title: 'Series' }
        ]
      }
    }
  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
  .content-table {
    margin: 25px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/serie/SerieList.vue